export const careersData = [
   {
    id: "JD-001",
    title: "Associate Software Engineer ",
    department: "Engineering",
    type: "Hybrid",
    location: "Hyderabad, India",
    experience: "4 - 6 Years",
    skills: [
      "C#",
      "Web API",
      "Entity Framework",
      "Angular",
      "SQL Server",
      "JavaScript",
      "HTML5",
      "CSS"
    ],
    description:
      "Join an innovative and fast-paced team-building software that allows litigation professionals to filter millions of documents down to those most important to their case using advanced techniques and artificial intelligence. you’ll be developing technology that addresses complex challenges such as data visualization, machine learning, distributed systems, large databases, and large-scale data processing",
  },
  {
    id: "JD-002",
    title: "Senior Software Engineer",
    department: "Engineering",
    type: "Hybrid",
    location: "Hyderabad, India",
    experience: "6 - 10 Years",
    skills: [
      "C#",
      "Web API",
      "Entity Framework",
      "Angular",
      "SQL Server",
      "JavaScript",
      "HTML5",
      "CSS"
    ],
    description:
      "We’re looking for a Senior Software Engineer to join our development team working on core products. You will collaborate with managers and developers on multiple features and be involved in the complete concept-to-delivery lifecycle of high-quality solutions. You should continuously update your technical skills as per evolving project requirements.",
  },
   {
    id: "JD-003",
    title: "Senior Software Engineer- Team Lead Backend",
    department: "Engineering",
    type: "Hybrid",
    location: "Hyderabad, India",
    experience: "11- 17 Years",
    skills: [
      "C#",
      "Web API",
      "SQL Server",
      "Lead experience"
      
    ],
    description:
      "We are seeking an experienced Senior Software Engineer, Team Lead to guide a team of backend engineers in building innovative software for litigation professionals. Our products enable users to filter millions of documents down to those most relevant to their cases, leveraging advanced techniques in data visualization, artificial intelligence, and large-scale data processing.",
  },
  {
    id: "JD-004",
    title: "Data Scientist",
    department: "Engineering",
    type: "Hybrid",
    location: "Hyderabad, India",
    experience: "2 - 4 Years",
    skills: [
      "Machine Learning",
      "Artificial Intelligence",
      "Python",
      "PyTorch",
      "Deep Learning",
      "Natural Language Processing (NLP)",
      "Statistics",
      "Mathematics"
    ],
    description:
      "We are seeking a talented Data Scientist to work on a cutting-edge semantic layer platform that accelerates next-generation AI, analytics, and decision intelligence. The role involves analyzing complex datasets, building and deploying machine learning models, and transforming data into actionable insights to support intelligent decision-making.",
  },
  {
    id: "JD-005",
    title: "Senior Python Developer",
    department: "Engineering",
    type: "Hybrid",
    location: "Hyderabad, India",
    experience: "4 - 7 Years",
    skills: [
      "Python",
      "Django",
      "Flask",
      "SQL",
      "Data Analytics",
      "LangChain",
      "RAG",
      "GenAI"
    ],
    description:
      "This role is responsible for developing next-generation ML and AI applications. You will collaborate with developers, product owners, and stakeholders to deliver high-quality software solutions and actively participate in agile development processes including sprint planning and retrospectives.",
  },
 
  
];
